module.exports = __webpack_public_path__ + "static/img/star-year-no2.8e10e141.png";